import React, {Component} from "react";
import Cookies from "universal-cookie";
import axios from "axios";
import {Buffer} from "buffer";
import {offerApiServices} from "../../services/offer/OfferApiService";
import {Button, Card, Checkbox, Col, Collapse, DatePicker, Divider, Dropdown, Input, Menu, message, Modal, Popover, Row, Select, Space, Spin, Tooltip, Typography} from "antd";
import AreaGroupCitySelect from "../../components/area/AreaGroupCitySelect";
import VehicleModelSelect from "../../components/vehicle-copan/VehicleModelSelect";
import VehicleVariantSelect from "../../components/vehicle-copan/VehicleVariantSelect";
import VehicleVariantColorSelect from "../../components/vehicle-copan/VehicleVariantColorSelect";
import LeasingSelect from "../../components/multifinance/Leasing";
import CurrencyInput from "react-currency-input-field";
import moment from "moment";
import {DownOutlined, InfoCircleOutlined, WarningOutlined} from "@ant-design/icons";
import {vehicleServices} from "../../services/autotrimitra/vehicleServices";
import currencyFormat from "../../helper/currencyFormat";
import TextArea from "antd/es/input/TextArea";
import {catalogOpenSearchServices} from "../../services/catalog/CatalogOpenSearch";
import {b2bService} from "../../services/b2b/B2bService";

const {Text} = Typography;
const {Panel} = Collapse;

class UpdateVehicleAndPromo extends Component<any, any> {
    private readonly initState!: any;
    private user = JSON.parse(Buffer.from(new Cookies().get('_u'), "base64").toString())

    constructor(props: any) {
        super(props);
        this.initState = {
            dealerCode: "",
            offerCode: "",
            fetchingDetailOffer: false,
            purchaseMethod: "",
            offerStatus: "",
            takeVehicleInDealer: false,
            vehicleBrand: null,
            promoCode: "",
            agentCode: "",
            notes: "",
            alternativeColor: "SAME_AS_ORDER",
            vehicleModel: "",
            vehicleYear: null,
            vehicleVariantCode: "",
            vehicleVariantName: "",
            vehicleVariantColorCode: "",
            vehicleVariantColorName: "",
            cityGroup: "",
            leasingCode: "",
            leasingName: "",
            fincoComission: 0,
            otr: 0,
            dpAmount: 0,
            installmentAmount: 0,
            tenor: 0,
            poTrackNumber: "",
            poCode: "",
            poPhoneNumber: "",
            poTime: moment(new Date(), 'YYYY-MM-DD'),
            poExpirePolicy: "",
            poExpiredAt: moment(new Date(), 'YYYY-MM-DD'),
            orderImagePo: "",
            indentCode: "",
            fetchingPo: false,
            showFetchPoResult: false,
            dataPo: {},
            showOpenSearch: false,
            fetchingOpenSearch: false,
            dataOpenSearch: {variantCode: "", searchText: ""},
            resultOpenSearch: {model_name: "", variant_code: "", variant_name: "", notes: "", id: ""},
            usedOpenSearch: {used: false, variant: false, color: false},
            feedbackLoading: false,
            cashbackAlreadyPaidOrReject: false,
        }
        this.state = {...this.initState}
    }

    async componentDidMount() {
        await this.promisedSetState({
            dealerCode: this.props.dealerCode,
            offerCode: this.props.offerCode,
            fetchingDetailOffer: true,
            purchaseMethod: "",
            offerStatus: "",
            showOpenSearch: false,
            fetchingOpenSearch: false,
            dataOpenSearch: {variantCode: "", searchText: ""},
            resultOpenSearch: {model_name: "", variant_code: "", variant_name: "", notes: "", id: ""},
            usedOpenSearch: {used: false, variant: false, color: false},
            feedbackLoading: false,
            cashbackAlreadyPaidOrReject: false,
        });

        await this.showOfferDetail();
    }

    async componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {
        if (this.props.dealerCode !== prevProps.dealerCode) {
            console.log('diff dealer');
        }

        if (this.props.offerCode !== prevProps.offerCode) {
            await this.promisedSetState({
                offerCode: this.props.offerCode,
                fetchingDetailOffer: true,
                purchaseMethod: "",
                offerStatus: "",
                showOpenSearch: false,
                fetchingOpenSearch: false,
                dataOpenSearch: {variantCode: "", searchText: ""},
                resultOpenSearch: {model_name: "", variant_code: "", variant_name: "", notes: "", id: ""},
                usedOpenSearch: {used: false, variant: false, color: false},
                feedbackLoading: false,
                cashbackAlreadyPaidOrReject: false,
            });
        }

        if (this.props.time !== prevProps.time) {
            await this.showOfferDetail();
        }
    }

    showOfferDetail = async () => {
        await this.promisedSetState({dealerCode: "", offerCode: "", dataDetailOffer: {}, fetchingDetailOffer: true, updateProcess: false, fetchingPo: false, showFetchPoResult: false, dataPo: {}});

        const sleep = (waitTimeInMs: number) => new Promise(resolve => setTimeout(resolve, waitTimeInMs));
        await sleep(100);

        await offerApiServices.getDetailOffer({
            companyCode: this.props.companyCode,
            offerCode: this.props.offerCode,
            getDetailCashback: true,
        }).then(async value => {
            await this.promisedSetState({
                dataDetailOffer: value.data.data,
                offerCode: value.data.data?.transaction_code,
                purchaseMethod: value.data.data?.purchase_method,
                offerStatus: value.data.data?.offer_status,
                cityGroup: value.data.data.area?.toUpperCase(),
                takeVehicleInDealer: value.data.data?.take_vehicle_in_dealer,
                vehicleBrand: value.data.data.vehicle?.brand_name?.toUpperCase(),
                vehicleModel: value.data.data.vehicle?.model_name?.toLowerCase(),
                vehicleVariantCode: value.data.data.vehicle?.variant_code?.toUpperCase(),
                vehicleYear: value.data.data.vehicle?.year?.toString() ?? null,
                vehicleVariantName: value.data.data.vehicle?.variant_name?.toLowerCase(),
                vehicleVariantColorCode: value.data.data.vehicle?.color_code?.toUpperCase(),
                vehicleVariantColorName: value.data.data.vehicle?.color_name?.toLowerCase(),
                promoCode: value.data.data?.detail_promo[0]?.code,
                agentCode: (value.data.data?.affiliate_code && value.data.data?.affiliate_code !== "NO_DATA") ? value.data.data?.affiliate_code : value.data.data?.agent_code,
                notes: value.data.data?.notes,
                alternativeColor: value?.data?.data?.vehicle?.alternative_color?.code,
                leasingCode: value.data.data?.credit?.finco_code?.toUpperCase(),
                leasingName: value.data.data?.credit?.finco_name?.toUpperCase(),
                fincoComission: value.data.data?.price_and_bill?.finco_commission,
                otr: value.data.data?.price_and_bill?.otr,
                dpAmount: value.data.data?.credit?.dp_amount,
                installmentAmount: value.data.data?.credit?.installment_amount,
                tenor: value.data.data?.credit?.tenor,
                poTrackNumber: value.data.data?.credit?.po_track_number,
                poCode: value.data.data?.credit?.po_code,
                poPhoneNumber: value.data.data?.credit?.po_phone_number,
                poTime: (value.data.data?.credit?.po_time) ? value.data.data?.credit?.po_time : moment(new Date(), 'YYYY-MM-DD'),
                poExpirePolicy: value.data.data?.credit?.po_expire_policy ?? 0,
                poExpiredAt: (value.data.data?.credit?.po_expired_at) ? value.data.data?.credit?.po_expired_at : moment(new Date(), 'YYYY-MM-DD'),
                orderImagePo: value.data.data?.credit?.po_image,
                indentCode: value.data.data?.indent_code,
                cashbackAlreadyPaidOrReject: value.data?.data_cashback?.cashback_already_paid_or_reject ?? false,
            });
            await sleep(2000);
            await this.promisedSetState({
                fetchingDetailOffer: false,
            });
        }).catch(async reason => {
            await this.promisedSetState({
                dataDetailOffer: {},
                fetchingDetailOffer: false,
            });
        });
    }

    onVehicleModelChange = (data: any) => {
        this.setState({vehicleModel: data?.value, vehicleVariantCode: null, vehicleVariantName: null, vehicleVariantColorCode: null, vehicleVariantColorName: null});
    }

    onVehicleVariantChange = (data: any) => {
        if (data) {
            const children = data.children.split(" - ");
            this.setState({vehicleVariantCode: data.value, vehicleVariantName: children[0], vehicleVariantColorCode: null, vehicleVariantColorName: null});
        }
    }

    onVehicleVariantColorChange = (data: any) => {
        if (data) {
            const children = data.children.split(" - ");
            this.setState({vehicleVariantColorCode: data.value, vehicleVariantColorName: children[1]});
        }
    }

    onFieldChange = <T extends keyof Pick<any, "alternativeColor" | "notes" | "takeVehicleInDealer" | "vehicleYear" | "vehicleBrand" | "promoCode" | "agentCode" | "poCode" | "indentCode" | "poTrackNumber" | "poTime" | "poExpiredAt" | "poExpirePolicy" | "poPhoneNumber" | "fincoCode" | "fincoComission" | "otr" | "dpAmount" | "installmentAmount" | "tenor">>(target: T, value: any) => {
        const currentState = {...this.state};
        switch (target) {
            case "alternativeColor":
                currentState.alternativeColor = value;
                break;
            case "notes":
                currentState.notes = value;
                break;
            case "takeVehicleInDealer":
                currentState.takeVehicleInDealer = value;
                break;
            case "vehicleYear":
                currentState.vehicleYear = value;
                break;
            case "vehicleBrand":
                currentState.vehicleBrand = value;
                break;
            case "promoCode":
                currentState.promoCode = value;
                break;
            case "agentCode":
                currentState.agentCode = value;
                break;
            case "fincoCode":
                currentState.fincoCode = value;
                break;
            case "poTrackNumber":
                currentState.poTrackNumber = value;
                break;
            case "fincoComission":
                currentState.fincoComission = value;
                break;
            case "otr":
                currentState.otr = value;
                break;
            case "installmentAmount":
                currentState.installmentAmount = value;
                break;
            case "dpAmount":
                currentState.dpAmount = value;
                break;
            case "tenor":
                currentState.tenor = value;
                break;
            case "poCode":
                currentState.poCode = value;
                break;
            case "poPhoneNumber":
                currentState.poPhoneNumber = value;
                break;
            case "poTime":
                currentState.poTime = value;
                break;
            case "poExpirePolicy":
                currentState.poExpirePolicy = value;
                break;
            case "poExpiredAt":
                currentState.poExpiredAt = value;
                break;
            case "indentCode":
                currentState.indentCode = value;
                break;
        }
        this.setState({
            ...currentState,
        });
    }

    onCityGroupChange = (data: any) => {
        this.setState({cityGroup: data.value, vehicleModel: null, vehicleVariantCode: null, vehicleVariantName: null, vehicleVariantColorCode: null, vehicleVariantColorName: null});
    }

    onLeasingChange = (data: any) => {
        this.setState({leasingCode: data.value?.toUpperCase(), leasingName: data.children?.toUpperCase()});
    }

    fetchOpenSearch = async () => {
        this.setState({
            fetchingOpenSearch: true,
            resultOpenSearch: {model_name: "", variant_code: "", variant_name: "", color_code: "", color_name: "", notes: "", id: ""},
            usedOpenSearch: {used: false, variant: false, color: false},
            feedbackLoading: false,
        });

        try {
            await catalogOpenSearchServices.getCatalogSearch({
                cityGroup: this.state.cityGroup,
                variantCode: this.state.dataOpenSearch?.variantCode,
                searchText: this.state.dataOpenSearch?.searchText,
                searchColor: (this.state?.dataPo?.colorName) ? this.state?.dataPo?.colorName : (this.state.dataDetailOffer?.notes ?? ""),
                otr: (this.state?.dataPo?.otr) ? this.state?.dataPo?.otr : 0,
            }).then(async resultOpenSearch => {
                await this.promisedSetState({
                    fetchingOpenSearch: false,
                    resultOpenSearch: {
                        model_name: resultOpenSearch?.data?.data?.model_name?.toLowerCase(),
                        variant_code: resultOpenSearch?.data?.data?.variant_code?.toUpperCase(),
                        variant_name: resultOpenSearch?.data?.data?.variant_name?.toLowerCase(),
                        color_code: resultOpenSearch?.data?.data?.color_code?.toUpperCase(),
                        color_name: resultOpenSearch?.data?.data?.color_name?.toLowerCase(),
                        notes: "*mohon lakukan croscheck.",
                        id: resultOpenSearch?.data?.meta?.search_log_id,
                    },
                    feedbackLoading: false,
                });
            });
        } catch (e: any) {
            this.setState({
                fetchingOpenSearch: false,
                resultOpenSearch: {model_name: "", variant_code: "", variant_name: "", notes: "Error: " + e, id: e?.message?.meta?.search_log_id},
                feedbackLoading: false,
            });
        }
    }

    feedBackOpenSearch = async (params: any) => {
        if (params?.variant && !params?.color) {
            await this.promisedSetState({
                feedbackLoading: true,
                vehicleModel: this.state.resultOpenSearch?.model_name?.toLowerCase(),
                vehicleVariantCode: this.state.resultOpenSearch?.variant_code?.toUpperCase(),
                vehicleVariantName: this.state.resultOpenSearch?.variant_name?.toLowerCase(),
                vehicleVariantColorCode: null,
                vehicleVariantColorName: null,
                usedOpenSearch: {used: true, variant: true, color: false}
            });
        }

        if (!params?.variant && !params?.color) {
            await this.promisedSetState({
                feedbackLoading: true,
                usedOpenSearch: {used: true, variant: false, color: false}
            });
        }

        if (params?.variant && params?.color) {
            await this.promisedSetState({
                feedbackLoading: true,
                vehicleModel: this.state.resultOpenSearch?.model_name?.toLowerCase(),
                vehicleVariantCode: this.state.resultOpenSearch?.variant_code?.toUpperCase(),
                vehicleVariantName: this.state.resultOpenSearch?.variant_name?.toLowerCase(),
                vehicleVariantColorCode: this.state.resultOpenSearch?.color_code?.toUpperCase(),
                vehicleVariantColorName: this.state.resultOpenSearch?.color_name?.toLowerCase(),
                usedOpenSearch: {used: true, variant: true, color: true}
            });

            try {
                await catalogOpenSearchServices.openSearchFeedBack({
                    id: this.state.resultOpenSearch?.id,
                    is_variant_relevant: true,
                    is_color_relevant: true,
                    correct_variant: {
                        code: this.state.resultOpenSearch?.variant_code?.toUpperCase(),
                        name: this.state.resultOpenSearch?.variant_name?.toLowerCase()
                    },
                    correct_color: {
                        name: this.state.resultOpenSearch?.color_code?.toUpperCase(),
                        code: this.state.resultOpenSearch?.color_name?.toLowerCase()
                    }
                }).then(feedBackResponse => {
                    console.log(feedBackResponse);
                });
            } catch (e) {
                console.log(e);
            }
        }
    }

    feedBackFalse = async () => {
        if (!this.state.vehicleVariantColorCode) {
            Modal.warning({title: 'Warning', content: "Mohon Lengkapi Variant & Warna kendaraan pada form edit offer terlebih dahulu, sebelum menekan feedback."});
            return;
        }

        try {
            await catalogOpenSearchServices.openSearchFeedBack({
                id: this.state.resultOpenSearch?.id,
                is_variant_relevant: this.state.usedOpenSearch?.variant,
                is_color_relevant: this.state.usedOpenSearch?.color,
                correct_variant: {
                    code: this.state.vehicleVariantCode?.toUpperCase(),
                    name: this.state.vehicleVariantName?.toLowerCase()
                },
                correct_color: {
                    name: this.state.vehicleVariantColorCode?.toUpperCase(),
                    code: this.state.vehicleVariantColorName?.toLowerCase()
                }
            }).then(feedBackResponse => {
                console.log(feedBackResponse);
            });
        } catch (e) {
            console.log(e);
        }

        await this.promisedSetState({
            usedOpenSearch: {
                used: false,
                variant: this.state.usedOpenSearch?.variant,
                color: this.state.usedOpenSearch?.color,
            }
        });

    }

    fetchPoB2b = async () => {
        this.setState({
            fetchingPo: true,
        });

        try {
            const response = await b2bService.getOfferData({offerCode: this.props.offerCode});
            if (response.data.data.purchaseOrder.track_number) {
                this.setState({poTrackNumber: response.data.data.purchaseOrder.track_number});
            }
            if (response.data.data.purchaseOrder.poNumber) {
                this.setState({poCode: response.data.data.purchaseOrder.poNumber});
            }
            if (response.data.data.purchaseOrder.pricing_scheme.otr) {
                this.setState({otr: response.data.data.purchaseOrder.pricing_scheme.otr});
            }
            if (response.data.data.purchaseOrder.pricing_scheme.tenor) {
                this.setState({tenor: response.data.data.purchaseOrder.pricing_scheme.tenor});
            }
            if (response.data.data.purchaseOrder.pricing_scheme.down_payment) {
                this.setState({dpAmount: response.data.data.purchaseOrder.pricing_scheme.down_payment});
            }
            if (response.data.data.purchaseOrder.pricing_scheme.installment) {
                this.setState({installmentAmount: response.data.data.purchaseOrder.pricing_scheme.installment});
            }

            message.info('Data berhasil diambil');

            await this.promisedSetState({
                fetchingPo: false,
            });
        } catch (e) {
            this.setState({
                fetchingPo: false,
                showFetchPoResult: true,
                dataPo: {error: 'error'}
            });
        }
    }

    fetchPoEpo = async () => {
        this.setState({
            fetchingPo: true,
            showFetchPoResult: false,
            dataPo: {},
            fetchingOpenSearch: false,
            resultOpenSearch: {model_name: "", variant_code: "", variant_name: "", notes: "", id: ""},
            feedbackLoading: false,
        });

        try {
            const response = await axios({
                method: "get",
                url: "https://asia-southeast2-amh-b2b.cloudfunctions.net/api-b2b/public/fetch-track-number",
                params: {"poNumber": this.state.poCode?.toUpperCase() ?? ""},
                headers: {"Content-Type": "application/json"},
            });

            await this.promisedSetState({
                fetchingPo: false,
                showFetchPoResult: true,
                dataPo: response.data?.data
            });

            this.setState({
                showOpenSearch: true,
                fetchingOpenSearch: false,
                dataOpenSearch: {
                    variantCode: response.data?.data?.variantCode ?? "",
                    searchText: response.data?.data?.vehicle ?? "",
                },
            });

            if (response.data?.data?.poNumber) {
                this.setState({poCode: response.data?.data?.poNumber});
            }
            if (response.data?.data?.otr) {
                this.setState({otr: response.data?.data?.otr});
            }
            if (response.data?.data?.tenor) {
                this.setState({tenor: response.data?.data?.tenor});
            }
            if (response.data?.data?.downPayment) {
                this.setState({dpAmount: response.data?.data?.downPayment});
            }
            if (response.data?.data?.installment) {
                this.setState({installmentAmount: response.data?.data?.installment});
            }

            if (response.data?.data?.poNumber?.toLowerCase() !== this.state.dataDetailOffer?.credit?.po_code?.toLowerCase()) {
                offerApiServices.getOffer({
                    searchPoCode: response.data?.data?.poNumber,
                }).then(async value => {
                    let tempDuplicateOfferCode = [];
                    for (const element of value.data.data) {
                        tempDuplicateOfferCode.push(element?.transaction_code);
                    }
                    Modal.warning({title: 'Warning', content: "Kode PO hasil fetch, telah digunakan oleh kode offer: " + tempDuplicateOfferCode?.toString()});
                }).catch(async e => {
                });
            }

            await this.fetchOpenSearch();
        } catch (e) {
            this.setState({
                fetchingPo: false,
                showFetchPoResult: true,
                dataPo: {error: 'error'}
            });
        }
    }

    onUpdateData = async () => {
        if (!this.state.vehicleVariantColorCode) {
            Modal.error({title: 'Proses Gagal', content: "Mohon Lengkapi Warna Kendaraan"});
            return false;
        }
        if (!this.state.vehicleYear) {
            Modal.error({title: 'Proses Gagal', content: "Mohon Lengkapi Tahun Kendaraan"});
            return false;
        }

        await this.promisedSetState({updateProcess: true});

        let modelUuid = "";
        let variantUuid = "";
        await vehicleServices.getVehicleVariant({
            code: this.state.vehicleVariantCode?.toUpperCase()
        }).then(dataFetchModel => {
            modelUuid = dataFetchModel.data.data[0]?.model_uuid;
            variantUuid = dataFetchModel.data.data[0]?.variant_uuid;
        });

        if (!modelUuid) {
            Modal.error({title: 'Proses Gagal', content: "Error Autotrimtra"});
            await this.promisedSetState({updateProcess: false});
            return false;
        }

        const dataUpdate = {
            update_type: "purchase-update",
            company: this.props.companyCode,
            admin_id: this.user,
            admin_name: this.user,
            dealer_code: this.state.dealerCode,
            offer_code: this.state.offerCode,
            agent_code: this.state.agentCode,
            area: this.state.cityGroup,
            promo_codes: (this.state.promoCode) ? [this.state.promoCode] : [],
            credit: {
                finco_code: this.state.leasingCode,
                finco_name: this.state.leasingName,
                finco_comission: this.state.fincoComission,
                otr: this.state.otr,
                installment_amount: this.state.installmentAmount,
                dp_amount: this.state.dpAmount,
                tenor: this.state.tenor,
                po_track_number: this.state.poTrackNumber,
                po_code: this.state.poCode,
                po_phone_number: this.state.poPhoneNumber,
                po_time: moment(this.state.poTime).format("YYYY-MM-DD") + " 10:00:00",
                po_expired_at: moment(this.state.poExpiredAt).format("YYYY-MM-DD") + " 10:00:00",
                po_image: this.state.orderImagePo,
                po_expire_policy: this.state.poExpirePolicy,
                po_data: {},
                credit_note: "",
                finco_branch: ""
            },
            take_vehicle_in_dealer: this.state.takeVehicleInDealer,
            vehicle: {
                brand_uuid: "afce6884-fc4d-4f7a-b784-09d2a2f7b903",
                brand_name: this.state.vehicleBrand,
                model_uuid: modelUuid,
                model_name: this.state.vehicleModel?.toLowerCase(),
                variant_uuid: variantUuid,
                variant_code: this.state.vehicleVariantCode?.toLowerCase(),
                variant_name: this.state.vehicleVariantName?.toLowerCase(),
                color_code: this.state.vehicleVariantColorCode,
                color: this.state.vehicleVariantColorName,
                alternative_color: {"code": (this.state?.alternativeColor) ? this.state?.alternativeColor : "SAME_AS_ORDER", "name": (this.state?.alternativeColor === "SAME_AS_ORDER") ? "warna sesuai pesanan" : "tanpa prferensi warna"},
                year: this.state.vehicleYear?.trim(),
            },
            indent_code: this.state.indentCode,
            notes: this.state.notes,
            update_bill: this.props.update_bill
        };

        try {
            await offerApiServices.updateOffer(dataUpdate)
                .then(successData => {
                    Modal.success({
                        title: 'Proses Sukses',
                        content: 'Offer berhasil di update '
                    });
                    this.setState({
                        updateProcess: false,
                    });
                    this.props.onCloseUpdateVehicleAndPromo("close");
                });
        } catch (e) {
            Modal.error({
                title: 'Proses Gagal',
                content: 'Server Menolak Inputan Anda :' + e
            });
            await this.promisedSetState({
                updateProcess: false,
            });
        }
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        const listPromoUsedName = [];
        for (const item of this.state.dataDetailOffer?.detail_promo ?? []) {
            listPromoUsedName.push(item?.code);
        }

        let showUpdatePo = false
        if (this.props.update_bill) {
            showUpdatePo = true
        } else {
            if (!this.state.dataDetailOffer?.price_and_bill?.bill_code) {
                showUpdatePo = true
            }
        }

        const menu = (
            <Menu>
                <Menu.Item key={1}>
                    <span onClick={event => this.feedBackOpenSearch({variant: true, color: false})} style={{cursor: "pointer"}}> Hanya Gunakan Variant</span>
                </Menu.Item>
                <Menu.Item key={2}>
                    <span onClick={event => this.feedBackOpenSearch({variant: false, color: false})} style={{cursor: "pointer"}}> Variant & Warna Tidak Sesuai</span>
                </Menu.Item>
            </Menu>
        );

        const menuSource = (
            <Menu>
                <Menu.Item key={1}>
                    <Button style={{width: "100%"}} loading={this.state.fetchingPo} onClick={() => this.fetchPoEpo()}> E-PO</Button>
                </Menu.Item>
                <Menu.Item key={2}>
                    <Button style={{width: "100%"}} loading={this.state.fetchingPo} onClick={() => this.fetchPoB2b()}> B2B</Button>
                </Menu.Item>
            </Menu>
        );

        const currentYear: number = new Date().getFullYear();
        const years: number[] = Array.from({length: 6}, (_, index) => currentYear - index);

        return (
            <React.Fragment>
                <div style={this.state.fetchingDetailOffer ? {} : {display: 'none'}} className={`spinCenter`}>
                    <Spin size="large"/>
                </div>

                <div style={!this.state.fetchingDetailOffer && !this.state.purchaseMethod ? {} : {display: 'none'}} className={`spinCenter`}>
                    Offer Code Not Found
                </div>

                <div style={!this.state.fetchingDetailOffer && this.state.purchaseMethod && this.state.offerStatus !== "OPEN" ? {} : {display: 'none'}}>
                    Offer not in OPEN Condition
                </div>

                <div style={!this.state.fetchingDetailOffer && this.state.purchaseMethod && this.state.offerStatus === "OPEN" ? {} : {display: 'none'}}>
                    <Row>
                        <Col xs={24} xl={14}>
                            <Card style={{margin: 3}} size="small" title="Data Sebelum Diubah">
                                <Row>
                                    <Col xs={24} xl={12} style={{fontSize: "90%"}}>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Kode Offer:</Col><Col xs={24} xl={16}>{this.state.offerCode}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Tanggal Offer:</Col><Col xs={24} xl={16}>{this.state.dataDetailOffer?.transaction_time?.substring(0, 10)}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Metode Pembelian:</Col><Col xs={24} xl={16}>{this.state.purchaseMethod}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Area:</Col><Col xs={24} xl={16}>{this.state.dataDetailOffer?.area}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Ambil di Dealer:</Col><Col xs={24} xl={16}>{(this.state.dataDetailOffer?.take_vehicle_in_dealer) ? "ya" : "tidak"}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Brand:</Col><Col xs={24} xl={16}>{this.state.dataDetailOffer?.vehicle?.brand_name}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Model:</Col><Col xs={24} xl={16}>{this.state.dataDetailOffer?.vehicle?.model_name}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Variant:</Col><Col xs={24} xl={16}>{this.state.dataDetailOffer?.vehicle?.variant_code} - {this.state.dataDetailOffer?.vehicle?.variant_name}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Warna:</Col><Col xs={24} xl={16}>{this.state.dataDetailOffer?.vehicle?.color_name} - ({this.state.dataDetailOffer?.vehicle?.color_code})</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Tahun Kendaraan:</Col><Col xs={24} xl={16}>{this.state.dataDetailOffer?.vehicle?.year}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Kode Promo:</Col><Col xs={24} xl={16}>{listPromoUsedName.toString()}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Kode Agen:</Col><Col xs={24} xl={16}>{this.state.dataDetailOffer?.agent_code}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Kode Affiliate:</Col><Col xs={24} xl={16}>{this.state.dataDetailOffer?.affiliate_code}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Catatan Offer:</Col><Col xs={24} xl={16}>{this.state.dataDetailOffer?.notes ?? ""}</Col></Row>
                                        <Row>
                                            <div style={this.state.cashbackAlreadyPaidOrReject ? {} : {display: 'none'}} className={`pt-10`}><i style={{fontSize: '85%', color: "darkred"}}>*offer telah memiliki riwayat paid / reject cashback. anda hanya dapat merubah sebagian data.</i></div>
                                        </Row>
                                    </Col>
                                    <Col xs={24} xl={12} style={this.state.purchaseMethod === 'credit' ? {fontSize: "90%"} : {display: 'none'}}>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>PO Track Number:</Col><Col xs={24} xl={16}>{this.state.dataDetailOffer?.credit?.po_track_number}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Kode PO:</Col><Col xs={24} xl={16}>{this.state.dataDetailOffer?.credit?.po_code?.toUpperCase()}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Finco:</Col><Col xs={24} xl={16}>{this.state.dataDetailOffer?.credit?.finco_code?.toUpperCase()} - {this.state.dataDetailOffer?.credit?.finco_name}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Branch Finco:</Col><Col xs={24} xl={16}>{this.state.dataDetailOffer?.credit?.finco_branch_code?.toUpperCase()} - {this.state.dataDetailOffer?.credit?.finco_branch}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>OTR:</Col><Col xs={24} xl={16}>{currencyFormat(this.state.dataDetailOffer?.price_and_bill?.otr)}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>DP:</Col><Col xs={24} xl={16}>{currencyFormat(this.state.dataDetailOffer?.credit?.dp_amount)}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Tenor @ Cicilan:</Col><Col xs={24} xl={16}>{this.state.dataDetailOffer?.credit?.tenor} @ {currencyFormat(this.state.dataDetailOffer?.credit?.installment_amount)}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Komisi Finco:</Col><Col xs={24} xl={16}>{currencyFormat(this.state.dataDetailOffer?.price_and_bill?.finco_commission)}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Kebijakan Expire PO:</Col><Col xs={24} xl={16}>{this.state.dataDetailOffer?.credit?.po_expire_policy} {this.state.dataDetailOffer?.credit?.po_expire_poilicy}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Expire PO:</Col><Col xs={24} xl={16}>{moment(this.state.dataDetailOffer?.credit?.po_expired_at).startOf('month').format("YYYY-MM-DD")}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Kode Inden:</Col><Col xs={24} xl={16}>{this.state.dataDetailOffer?.indent_code}</Col></Row>
                                        <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Gambar PO:</Col><Col xs={24} xl={16}>{this.state.dataDetailOffer?.credit?.po_image && <a target={'_blank'} rel="noreferrer" href={this.state.dataDetailOffer?.credit?.po_image}> Lihat Image </a>}</Col></Row>

                                        <Collapse defaultActiveKey={['2']} ghost>
                                            <Panel header="Data PO" key="1">
                                                <Row className={`pt-5`}><Col xs={24} xl={10} className={`col-grey-small`}>Tanggal PO:</Col><Col xs={24} xl={14}>{this.state.dataDetailOffer?.credit?.po_time?.substring(0, 10)}</Col></Row>
                                                <Row className={`pt-5`}><Col xs={24} xl={10} className={`col-grey-small`}>Nomor Telpon PO:</Col><Col xs={24} xl={14}>{this.state.dataDetailOffer?.credit?.po_phone_number}</Col></Row>
                                                <Row className={`pt-5`}><Col xs={24} xl={10} className={`col-grey-small`}> &nbsp; &nbsp; Kode Variant PO:</Col><Col xs={24} xl={14}>{this.state.dataDetailOffer?.credit?.po_variant_code}</Col></Row>
                                                <Row className={`pt-5`}><Col xs={24} xl={10} className={`col-grey-small`}> &nbsp; &nbsp; Nama Variant PO:</Col><Col xs={24} xl={14}>{this.state.dataDetailOffer?.credit?.po_vehicle_name}</Col></Row>
                                                <Row className={`pt-5`}><Col xs={24} xl={10} className={`col-grey-small`}> &nbsp; &nbsp; Tahun Kendaraan PO:</Col><Col xs={24} xl={14}>{this.state.dataDetailOffer?.credit?.po_vehicle_year}</Col></Row>
                                                <Row className={`pt-5`}><Col xs={24} xl={10} className={`col-grey-small`}> &nbsp; &nbsp; Nomor KTP Pemilik PO:</Col><Col xs={24} xl={14}>{this.state.dataDetailOffer?.credit?.po_ownership_id_card_number}</Col></Row>
                                                <Row className={`pt-5`}><Col xs={24} xl={10} className={`col-grey-small`}> &nbsp; &nbsp; Nama Pemilik PO:</Col><Col xs={24} xl={14}>{this.state.dataDetailOffer?.credit?.po_ownership_full_name}</Col></Row>
                                                <Row className={`pt-5`}><Col xs={24} xl={10} className={`col-grey-small`}> &nbsp; &nbsp; Nomor KTP Pemesan PO:</Col><Col xs={24} xl={14}>{this.state.dataDetailOffer?.credit?.po_order_maker_id_card_number}</Col></Row>
                                                <Row className={`pt-5`}><Col xs={24} xl={10} className={`col-grey-small`}> &nbsp; &nbsp; Nama Pemesan PO:</Col><Col xs={24} xl={14}>{this.state.dataDetailOffer?.credit?.po_order_maker_full_name}</Col></Row>
                                            </Panel>
                                        </Collapse>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                        <Col xs={24} xl={10} style={this.state.purchaseMethod === 'credit' ? {} : {display: 'none'}}>
                            <div style={!showUpdatePo ? {display: 'none'} : {}}>
                                <Card style={{margin: 3}} size="small" title="Data PO dari leasing">
                                    <Row>
                                        <Col xs={24} xl={14}>
                                            <Dropdown overlay={menuSource}>
                                                <Button loading={this.state.fetchingPo} size={"small"} type={"primary"}><Space>Ambil Data PO<DownOutlined/></Space></Button>
                                            </Dropdown>

                                            <br/><br/>
                                            <div style={this.state.showFetchPoResult ? {fontSize: "75%"} : {display: 'none'}}>
                                                <Row className={`pt-5`}>
                                                    <Col xs={24} xl={8} className={`col-grey-small`}>Kode PO:</Col>
                                                    <Col xs={24} xl={16}>
                                                        {this.state?.dataPo?.poNumber}
                                                        <span style={(this.state?.dataPo?.poNumber?.toUpperCase() !== this.state.dataDetailOffer?.credit?.po_code?.toUpperCase()) ? {} : {display: 'none'}}>
                                                        &nbsp; &nbsp;
                                                            <Tooltip title="Data PO leasing berbeda dengan data offer" color={'red'}>
                                                            <WarningOutlined className={'small-avatar-danger'}/>
                                                        </Tooltip>
                                                    </span>
                                                    </Col>
                                                </Row>
                                                <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Nama KTP Pemilik:</Col><Col xs={24} xl={16}>{this.state?.dataPo?.documentOwnershipFullName}</Col></Row>
                                                <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Nomor KTP Pemilik:</Col><Col xs={24} xl={16}>{this.state?.dataPo?.ownerIdCardNumber ?? ""}</Col></Row>
                                                <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Nama KTP Pemesan:</Col><Col xs={24} xl={16}>{this.state?.dataPo?.guarantorFullName}</Col></Row>
                                                <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Nomor KTP Pemesan:</Col><Col xs={24} xl={16}>{this.state?.dataPo?.guarantorIdCardNumber}</Col></Row>
                                                <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Nomor Telpon Pemesan:</Col><Col xs={24} xl={16}>{this.state?.dataPo?.phoneNumber}</Col></Row>
                                                <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Kode Variant:</Col><Col xs={24} xl={16}>{this.state?.dataPo?.variantCode}</Col></Row>
                                                <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Nama Variant:</Col><Col xs={24} xl={16}>{this.state?.dataPo?.vehicle}</Col></Row>
                                                <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Tahun Kendaraan:</Col><Col xs={24} xl={16}>{this.state?.dataPo?.year}</Col></Row>
                                                <Row className={`pt-5`}><Col xs={24} xl={8} className={`col-grey-small`}>Warna Kendaraan:</Col><Col xs={24} xl={16}>{this.state?.dataPo?.colorName}</Col></Row>
                                                <Row className={`pt-5`}>
                                                    <Col xs={24} xl={8} className={`col-grey-small`}>OTR:</Col>
                                                    <Col xs={24} xl={16}>
                                                        {currencyFormat(this.state?.dataPo?.otr)}
                                                        <span style={(this.state?.dataPo?.otr !== this.state.dataDetailOffer?.price_and_bill?.otr) ? {} : {display: 'none'}}>
                                                        &nbsp; &nbsp;<Tooltip title="Data PO leasing berbeda dengan data offer" color={'red'}><WarningOutlined className={'small-avatar-danger'}/></Tooltip>
                                                    </span>
                                                    </Col>
                                                </Row>
                                                <Row className={`pt-5`}>
                                                    <Col xs={24} xl={8} className={`col-grey-small`}>DP:</Col>
                                                    <Col xs={24} xl={16}>
                                                        {currencyFormat(this.state?.dataPo?.downPayment)}
                                                        <span style={(this.state?.dataPo?.downPayment !== this.state.dataDetailOffer?.credit?.dp_amount) ? {} : {display: 'none'}}>
                                                        &nbsp; &nbsp;
                                                            <Tooltip title="Data PO leasing berbeda dengan data offer" color={'red'}>
                                                           <WarningOutlined className={'small-avatar-danger'}/>
                                                        </Tooltip>
                                                    </span>
                                                    </Col>
                                                </Row>
                                                <Row className={`pt-5`}>
                                                    <Col xs={24} xl={8} className={`col-grey-small`}>Tenor @ Cicilan:</Col>
                                                    <Col xs={24} xl={16}>
                                                        {this.state?.dataPo?.tenor} @ {currencyFormat(this.state?.dataPo?.installment)}
                                                        <span style={(this.state?.dataPo?.tenor !== this.state.dataDetailOffer?.credit?.tenor) ? {} : {display: 'none'}}>
                                                        &nbsp; &nbsp;
                                                            <Tooltip title="Data PO leasing berbeda dengan data offer" color={'red'}>
                                                            <WarningOutlined className={'small-avatar-danger'}/>
                                                        </Tooltip>
                                                    </span>
                                                        <span style={(this.state?.dataPo?.installment !== this.state.dataDetailOffer?.credit?.installment_amount) ? {} : {display: 'none'}}>
                                                        &nbsp; &nbsp;
                                                            <Tooltip title="Data PO leasing berbeda dengan data offer" color={'red'}>
                                                            <WarningOutlined className={'small-avatar-danger'}/>
                                                        </Tooltip>
                                                    </span>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                        <Col xs={24} xl={10}>
                                            <div style={this.state.showOpenSearch ? {fontSize: "75%"} : {display: 'none'}}>
                                                <Button type={"primary"} size={`small`} loading={this.state.fetchingOpenSearch} onClick={() => this.fetchOpenSearch()}> Gunakan Open Seacrh</Button>

                                                <Popover placement="leftTop" content={(
                                                    <div>membantu menerjemahkan string variant motor yg didapatkan dari data PO leasing <br/> Secara otomatis setelah menekan tombol <Text code>Ambil Data PO</Text> atau Jika tombol <Text code>Open Search Variant</Text>, system akan memberikan saran model, variant, dan warna.<br/><br/>Jika hasil saran yg diberikan system dirasa sesuai,<br/>anda dapat menggunakanya dengan menekan tombol <Text code>Ya, Gunakan variant & warna</Text> jika hanya variant
                                                        yang cocok namun warna tidak sesuai, silakan klik dropdown pada tombol, untuk memilih kondisi yang sesuai.<br/><br/>Jika hasil tidak sesuai,<br/>mohon melengkapi model dan variant pada form update offer,<br/> kemudian
                                                        tekan tombol <Text code>Kirim Feedback</Text><br/> untuk membantu menyempurnakan fasilitas Open Search</div>)} title="Open Search Variant">
                                                    <InfoCircleOutlined style={{fontSize: "150%", cursor: "help", marginLeft: 10}} twoToneColor="#52c41a"/>
                                                </Popover>
                                                <br/><br/>
                                                <div style={this.state?.resultOpenSearch?.model_name ? {} : {display: 'none'}}>
                                                    <Row className={`pt-5`}><Col xs={24} xl={24} className={`col-grey-small`}>Model Variant:</Col><Col xs={24} xl={24}>{this.state?.resultOpenSearch?.model_name}</Col></Row>
                                                    <Row className={`pt-5`}><Col xs={24} xl={24} className={`col-grey-small`}>Kode Variant:</Col><Col xs={24} xl={24}>{this.state?.resultOpenSearch?.variant_code}</Col></Row>
                                                    <Row className={`pt-5`}><Col xs={24} xl={24} className={`col-grey-small`}>Nama Variant:</Col><Col xs={24} xl={24}>{this.state?.resultOpenSearch?.variant_name}</Col></Row>
                                                    <Row className={`pt-5`}><Col xs={24} xl={24} className={`col-grey-small`}>Kode / Nama Warna:</Col><Col xs={24} xl={24}>{this.state?.resultOpenSearch?.color_code} - {this.state?.resultOpenSearch?.color_name}</Col></Row>
                                                </div>

                                                <div style={this.state?.resultOpenSearch?.notes ? {} : {display: 'none'}}>
                                                    <div style={this.state?.feedbackLoading ? {display: 'none'} : {marginTop: 20, fontSize: "80%"}}>
                                                        <i style={{fontSize: "110%"}}>Apakah Sudah Relevan?<br/><br/></i>
                                                        <Dropdown.Button
                                                            size={"small"}
                                                            type={"primary"}
                                                            icon={<DownOutlined/>}
                                                            overlay={menu}
                                                            onClick={() => this.feedBackOpenSearch({variant: true, color: true})}
                                                        >
                                                            <span style={{fontSize: "75%"}}>Ya, Gunakan variant & warna</span>
                                                        </Dropdown.Button>
                                                    </div>

                                                    <div style={(this.state?.usedOpenSearch?.used && !(this.state?.usedOpenSearch?.variant && this.state?.usedOpenSearch?.color)) ? {marginTop: 20, fontSize: "80%"} : {display: 'none'}}>
                                                        <Button type={"primary"} size={`small`} onClick={() => this.feedBackFalse()} danger> <span style={{fontSize: "75%"}}>Kirim Feedback</span></Button>
                                                    </div>

                                                    <br/>
                                                    <i style={{fontSize: '85%', color: "darkred"}}>{this.state?.resultOpenSearch?.notes}</i><br/>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={24} xl={24}>
                                            <div style={this.state.showFetchPoResult ? {fontSize: "75%"} : {display: 'none'}}>
                                                <br/>
                                                <span style={(this.state?.dataPo?.poNumber?.toUpperCase()) ? {} : {display: 'none'}}>
                                                <i style={{fontSize: '85%', color: "darkred"}}>*nilai form kredit dibawah (kode PO, OTR, DP, Tenor, Cicilan) telah disesuaikan dengan data leasing. mohon lakukan croscheck.</i><br/>
                                                <i style={{fontSize: '85%', color: "darkred"}}>*Admin tidak wajib melakukan upload bukti / gambar PO.</i><br/>
                                            </span>
                                                <span style={(!this.state?.dataPo?.poNumber?.toUpperCase()) ? {} : {display: 'none'}}>
                                                <i style={{fontSize: '85%', color: "darkred"}}>*Data PO Leasing tidak valid.</i><br/>
                                                <i style={{fontSize: '85%', color: "darkred"}}>*Admin diwajibkan melakukan upload bukti / gambar PO.</i><br/>
                                            </span>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card>
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={24} xl={12} className={`pad-10`}>
                            <div style={this.state.cashbackAlreadyPaidOrReject ? {display: 'none'} : {}}>
                                <div className={`mt-5`}>
                                    <i className={`small-text-grey`}>Area</i><br/>
                                    <AreaGroupCitySelect companyCode={this.props.companyCode.toUpperCase()} onCityGroupChangeProps={this.onCityGroupChange} dealerCode={this.state.dealerCode} value={this.state.cityGroup} time={Math.floor(+new Date() / 1000)}/>
                                </div>
                                <div className={`mt-5`}>
                                    <i className={`small-text-grey`}>Brand</i><br/>
                                    <Select
                                        onChange={value => this.onFieldChange("vehicleBrand", value)}
                                        value={this.state.vehicleBrand}
                                        style={{width: "100%"}}
                                        placeholder={`Pilih Merk Kendaraan`}
                                    >
                                        <Select.Option key={`HONDA`} value={`HONDA`}>{`Honda`}</Select.Option>
                                        <Select.Option key={`CHERY`} value={`CHERY`}>{`Chery`}</Select.Option>
                                        <Select.Option key={`NETA`} value={`NETA`}>{`Neta`}</Select.Option>
                                    </Select>
                                </div>
                                <div className={`mt-5`}>
                                    <i className={`small-text-grey`}>Model</i><br/>
                                    <VehicleModelSelect onVehicleModelChangeProps={this.onVehicleModelChange} companyCode={this.props.companyCode} cityGroup={this.state.cityGroup} value={this.state.vehicleModel} brandCode={this.state.vehicleBrand} category={"motorcycle"} time={Math.floor(+new Date() / 1000)}/>
                                </div>
                            </div>
                            <div className={`mt-5`}>
                                <i className={`small-text-grey`}>Variant</i><br/>
                                <VehicleVariantSelect onVehicleVariantChangeProps={this.onVehicleVariantChange} companyCode={this.props.companyCode} cityGroup={this.state.cityGroup} brandCode={this.state.vehicleBrand} modelCode={this.state.vehicleModel} value={this.state.vehicleVariantCode} time={Math.floor(+new Date() / 1000)}/>
                            </div>
                            <div className={`mt-5`}>
                                <i className={`small-text-grey`}>Warna Variant</i><br/>
                                <VehicleVariantColorSelect onVehicleVariantColorChangeProps={this.onVehicleVariantColorChange} companyCode={this.props.companyCode} cityGroup={this.state.cityGroup} brandCode={this.state.vehicleBrand} modelCode={this.state.vehicleModel} variantCode={this.state.vehicleVariantCode} value={this.state.vehicleVariantColorCode} time={Math.floor(+new Date() / 1000)}/>
                            </div>

                            <div className={`mt-5`}>
                                <i className={`small-text-grey`}>Preferensi Warna</i><br/>
                                <Select
                                    onChange={value => this.onFieldChange("alternativeColor", value)}
                                    value={this.state.alternativeColor}
                                    style={{width: "100%"}}
                                    placeholder={`Pilih Preverensi Warna`}
                                >
                                    <Select.Option key={`SAME_AS_ORDER`} value={`SAME_AS_ORDER`}>{`warna sesuai pesanan`}</Select.Option>
                                    <Select.Option key={`NO_PREFERENCE`} value={`NO_PREFERENCE`}>{`tanpa prferensi warna`}</Select.Option>
                                </Select>
                            </div>

                            <div className={`mt-5`}>
                                <i className={`small-text-grey`}>Tahun Kendaraan</i><br/>
                                <Select
                                    showSearch
                                    style={{width: "100%"}}
                                    placeholder="Pilih Tahun"
                                    optionFilterProp="children"
                                    onChange={value => this.onFieldChange("vehicleYear", value.toString())}
                                    value={this.state.vehicleYear}
                                >
                                    {years.map((year) => (
                                        <Select.Option key={year} value={year}>
                                            {year}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </div>
                            <div style={this.state.cashbackAlreadyPaidOrReject ? {display: 'none'} : {}} className={`mt-5`}>
                                <i className={`small-text-grey`}>Kode Promo</i><br/>
                                <Input disabled={(this.props.update_bill) ? false : !!(this.state.dataDetailOffer?.price_and_bill?.bill_code)} value={this.state.promoCode} placeholder="Promo" onChange={event => this.onFieldChange("promoCode", event.target.value)}/>
                            </div>
                            <div style={this.state.cashbackAlreadyPaidOrReject ? {display: 'none'} : {}} className={`mt-5`}>
                                <i className={`small-text-grey`}>Kode Agen / Kode Affiliate</i> <i style={{fontSize: "70%", color: "red"}}>*jika terdapat kode affiliate, silakan inputkan kode affiliate</i><br/>
                                <Input
                                    disabled={true}
                                    value={this.state.agentCode}
                                    placeholder="Kode Agen"
                                    // onChange={event => this.onFieldChange("agentCode", event.target.value)}
                                />
                            </div>
                            <div style={this.state.cashbackAlreadyPaidOrReject ? {display: 'none'} : {}} className={`mt-5`}>
                                <i className={`small-text-grey`}>Catatan</i><br/>
                                <TextArea value={this.state.notes} onChange={event => this.onFieldChange("notes", event.target.value)} placeholder="Catatan" autoSize={{minRows: 2}}/>
                            </div>
                            <div className={`mt-5`}>
                                <br/>
                                <Checkbox checked={this.state.takeVehicleInDealer} onChange={e => this.onFieldChange("takeVehicleInDealer", e.target.checked)}> <span className={`divider-stock-purchase`}> Ambil di Dealer </span> </Checkbox>
                            </div>
                        </Col>

                        <Col xs={24} xl={12} className={`pad-10`} style={this.state.purchaseMethod === 'credit' ? {} : {display: 'none'}}>
                            <div style={this.state.cashbackAlreadyPaidOrReject ? {display: 'none'} : {}}>
                                <Divider orientation="left" plain>
                                    <i>Data Credit</i>
                                </Divider>
                                <div className={`mt-5`} style={{paddingTop: 10}}>
                                    <i className={`small-text-grey`}>Kode Finco</i><br/>
                                    <LeasingSelect disable={true} onLeasingChangeProps={this.onLeasingChange} value={this.state.leasingCode}/>
                                </div>
                                <div className={`mt-5`}>
                                    <i className={`small-text-grey`}>PO Track Number</i><br/>
                                    <Input
                                        disabled={true}
                                        value={this.state.poTrackNumber}
                                        placeholder="PO Track Number"
                                        // onChange={event => this.onFieldChange("poTrackNumber", event.target.value)}
                                    />
                                </div>
                                <div className={`mt-5`}>
                                    <i className={`small-text-grey`}>Kode PO</i><br/>
                                    <Input
                                        disabled={true}
                                        value={this.state.poCode}
                                        placeholder="Kode PO"
                                        // onChange={event => this.onFieldChange("poCode", event.target.value)}
                                    />
                                </div>
                                <div className={`mt-5`}>
                                    <i className={`small-text-grey`}>OTR</i><br/>
                                    <CurrencyInput
                                        disabled={true}
                                        className={'ant-input'}
                                        value={this.state.otr}
                                        // onValueChange={value => this.onFieldChange("otr", value ? parseFloat(value) : 0)}
                                    />
                                </div>
                                <div className={`mt-5`}>
                                    <i className={`small-text-grey`}>DP</i><br/>
                                    <CurrencyInput
                                        disabled={true}
                                        className={'ant-input'}
                                        value={this.state.dpAmount}
                                        // onValueChange={value => this.onFieldChange("dpAmount", value ? parseFloat(value) : 0)}
                                    />
                                </div>
                                <div className={`mt-5`}>
                                    <i className={`small-text-grey`}>Cicilan</i><br/>
                                    <CurrencyInput
                                        disabled={true}
                                        className={'ant-input'}
                                        value={this.state.installmentAmount}
                                        // onValueChange={value => this.onFieldChange("installmentAmount", value ? parseFloat(value) : 0)}
                                    />
                                </div>
                                <div className={`mt-5`}>
                                    <i className={`small-text-grey`}>Tenor</i><br/>
                                    <CurrencyInput
                                        disabled={true}
                                        className={'ant-input'}
                                        value={this.state.tenor}
                                        // onValueChange={value => this.onFieldChange("tenor", value ? parseFloat(value) : 0)}
                                    />
                                </div>
                                <div style={{display: "none"}} className={`mt-5`}>
                                    <i className={`small-text-grey`}>Komisi Finco</i><br/>
                                    <CurrencyInput className={'ant-input'} value={this.state.fincoComission} onValueChange={value => this.onFieldChange("fincoComission", value ? parseFloat(value) : 0)}/>
                                </div>
                                <div style={{display: "none"}} className={`mt-5`}>
                                    <i className={`small-text-grey`}>PO Nomor Telpon</i><br/>
                                    <Input value={this.state.poPhoneNumber} placeholder="PO Nomor Telpon" onChange={event => this.onFieldChange("poPhoneNumber", event.target.value)}/>
                                </div>
                                <div style={{display: "none"}} className={`mt-5`}>
                                    <i className={`small-text-grey`}>PO Tanggal</i><br/>
                                    <DatePicker value={moment(this.state.poTime, 'YYYY-MM-DD')} onChange={event => this.onFieldChange("poTime", event)} format={'YYYY-MM-DD'} style={{width: "100%"}}/>
                                </div>
                                <div style={{display: "none"}} className={`mt-5`}>
                                    <i className={`small-text-grey`}>Kebijakan Expire PO</i><br/>
                                    <CurrencyInput className={'ant-input'} value={this.state.poExpirePolicy} onValueChange={value => this.onFieldChange("poExpirePolicy", value ? parseFloat(value) : 0)}/>
                                </div>
                                <div style={{display: "none"}} className={`mt-5`}>
                                    <i className={`small-text-grey`}>Expire PO</i><br/>
                                    <DatePicker value={moment(this.state.poExpiredAt, 'YYYY-MM-DD')} onChange={event => this.onFieldChange("poExpiredAt", event)} format={'YYYY-MM-DD'} style={{width: "100%"}}/>
                                </div>
                                <div className={`mt-5`}>
                                    <i className={`small-text-grey`}>Kode Inden</i><br/>
                                    <Input value={this.state.indentCode} placeholder="Kode Inden" onChange={event => this.onFieldChange("indentCode", event.target.value)}/>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <br/>
                    <i style={{fontSize: '85%', color: "darkred"}}>*mohon lakukan croscheck, dengan melihat detail offer setelah proses update selesai.</i><br/><br/>
                    <Button type={"primary"} loading={this.state.updateProcess} onClick={() => this.onUpdateData()}> Update Data</Button>
                </div>
            </React.Fragment>
        )
    }
}

export default UpdateVehicleAndPromo;
